export function compareTimes(time1: Date, time2: Date) {
  // Extract hours, minutes, and seconds
  const hours1 = time1.getHours();
  const minutes1 = time1.getMinutes();
  const seconds1 = time1.getSeconds();

  const hours2 = time2.getHours();
  const minutes2 = time2.getMinutes();
  const seconds2 = time2.getSeconds();

  if (hours1 !== hours2) {
    return hours1 < hours2;
  }

  if (minutes1 !== minutes2) {
    return minutes1 < minutes2;
  }

  if (seconds1 !== seconds2) {
    return seconds1 < seconds2;
  }

  return true;
}
